import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      justifyContent: "center",
      flexDirection: "row",
      height: "100%",
      "& > div": {
        marginTop: 84,
        marginBottom: 84,
        width: 360,
        textAlign: "center",
      },
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: `center`,
    },
    label: {
      ...theme.fonts.label1,
      color: theme.colors.textSubtle,
      marginBottom: 16,
    },
    credentials: {
      ...theme.fonts.h4,
      color: theme.colors.textDefault,
    },
    modalRoot: {
      width: 560,
      maxWidth: "100%",
    },
    modalHeader: {
      ...theme.fonts.h4,
      color: theme.colors.textDefault,
      margin: "32px 0 16px 0",
    },
    modalDetailsText: {
      ...theme.fonts.p1,
      color: theme.colors.textSubtle,
      marginBottom: 48,
      paddingLeft: 16,
    },
    currentUsernameField: {
      marginBottom: "16px",
      marginTop: "32px",
      textAlign: "left",
    },
    footerButtons: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: 40,
      "& button": {
        marginLeft: 8,
      },
    },

    confirmationBody: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: 560,
      maxWidth: "100%",
      margin: "48px 0 34px 0",
    },
    checkIconBackground: {
      width: 60,
      height: 60,
      backgroundColor: theme.colors.affirmation,
      borderRadius: "50%",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
    },
    checkIcon: {
      color: theme.colors.textPrimaryAction,
      fontSize: 36,
    },
    confirmationHeader: {
      ...theme.fonts.h3,
      color: theme.colors.textDefault,
      margin: "24px 0 8px 0",
    },
    conformationText: {
      ...theme.fonts.p1,
      color: theme.colors.textDefault,
      marginBottom: 32,
    },
    passwordTextField: {
      marginTop: 24,
    },
    userNameLabel: {
      ...theme.fonts.h5,
      display: "flex",
      alignItems: "center",
      textAlign: "center",
      color: theme.colors.action,
      justifyContent: "center",
      marginRight: 4,
    },
    userName: {
      ...theme.fonts.p2,
      color: theme.colors.textSubtle,
    },
    nameContainer: {
      justifyContent: "center",
      display: "flex",
      alignItems: "center",
      marginBottom: "32px",
      flexFlow: "wrap",
    },
    detailedErrorMessage: {
      ...theme.fonts.p2,
      backgroundColor: theme.colors.background1,
      color: theme.colors.error,
      border: `1px solid ${theme.colors.divider}`,
      borderRadius: 6,
      padding: 16,
      marginTop: 32,
    },
    "@media (max-width: 476px)": {
      container: {
        padding: "32px 24px",
      },
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
